/* Gravur-MAX (Webstra 10/2026): Jedes Teil eines Sets (Glas 2, Holzbox …) einzeln gravierbar.
   Ergänzt die Foto-Vorschau aus gm-layout-v2.js, ohne sie zu verändern: Standard ist "gleiche Gravur wie Glas 1".
   Wird der Haken entfernt, bekommt das Teil eigene Felder (eigene Line-Item-Properties, z. B. "Glas 2: Erster Name").
   Motiv und Schrift bleiben für alle Teile gleich. */
(function(){
  if(window.__wbInd)return;window.__wbInd=1;
  var GM=window.GM=window.GM||{};
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function fire(el,t){el.dispatchEvent(new Event(t,{bubbles:true}));}

  /* Gleiche Suche wie gm-layout-v2.js: welches Layout (Set + Motiv) gilt für dieses Produkt */
  function findLayout(){
    var f=(window.GM_LAY||{})[window.GM_PREFIX||'gm-preview-puccini'];
    if(!f)return null;
    var v='';
    document.querySelectorAll('variant-selects-cust a.mo-item').forEach(function(a){
      if(a.getAttribute('href').split('?')[0]===location.pathname){var t=a.querySelector('.item-title');v=t?t.textContent.trim():'';}
    });
    var h=(document.querySelector('.product__title h1')||{}).textContent||'';
    var b=/holzbox\s+gro/i.test(h)?'2ghg':/holzbox\s+klein/i.test(h)?'1ghk':/2\s*Gl(ä|ae)ser/i.test(h)?'2g':/holzbox/i.test(h)?null:'1g';
    var x=location.pathname.split('/').pop().replace(/^weinglas-mit-gravur-leonardo-puccini-/,'');
    for(var y in f.m){if(f.m[y][x]&&f.sets[y]){b=y;break;}}
    if(!b||!f.sets[b]||!f.m[b])return null;
    var slug=String(v).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    var E=f.m[b][x]||f.m[b][slug];
    return E?{E:E,set:f.sets[b]}:null;
  }

  function css(){
    if(document.getElementById('wb-ind-css'))return;
    var s=document.createElement('style');s.id='wb-ind-css';
    s.textContent=".gm-cfg .wb-ind__head{margin:0 0 10px;font:800 14px/20px var(--wb-sans,\"Nunito Sans\",sans-serif);color:var(--wb-ink,#14232b)}.gm-cfg .wb-ind{display:flex;flex-direction:column;gap:10px;margin:16px 0 4px}.gm-cfg .wb-ind__item{border:1.5px solid var(--wb-line,#d5e2e8);border-radius:14px;background:#fff;overflow:hidden}.gm-cfg .wb-ind__toggle{display:flex;align-items:flex-start;gap:12px;margin:0;padding:14px 16px;cursor:pointer;font:400 15px/22px var(--wb-sans,\"Nunito Sans\",sans-serif);color:var(--wb-ink,#14232b)}.gm-cfg .wb-ind__toggle input{flex:none;width:20px;height:20px;margin:1px 0 0;accent-color:var(--wb-deep,#0b6e8a);cursor:pointer}.gm-cfg .wb-ind__toggle b{font-weight:800}.gm-cfg .wb-ind__toggle:focus-within{outline:3px solid var(--wb-brand,#42abcc);outline-offset:-3px;border-radius:14px}.gm-cfg .wb-ind__fields{padding:0 16px 14px;border-top:1px solid var(--wb-line,#d5e2e8);background:var(--wb-alt,#f4f8fa)}.gm-cfg .wb-ind__fields[hidden]{display:none}.gm-cfg .wb-ind__sub{margin:12px 0 8px;font:800 13px/18px var(--wb-sans,\"Nunito Sans\",sans-serif);color:var(--wb-muted,#52646d);text-transform:uppercase;letter-spacing:.06em}.gm-cfg .wb-ind__fields .gm-field + .gm-field{margin-top:12px}.gm-cfg .wb-ind__fields input[type=text]{width:100%;font-family:var(--font-body-family),sans-serif!important;font-size:1.6rem!important;letter-spacing:normal!important}";
    document.head.appendChild(s);
  }

  function init(){
    var wrap=document.querySelector('.gm-cfg--lay');
    if(!wrap||wrap.__wbInd||!GM.rows||!GM.render)return false;
    var L=findLayout();
    if(!L||!L.set.surf||L.set.surf.length<2)return true;
    var E=L.E,surf=L.set.surf;
    wrap.__wbInd=1;
    css();

    /* Namen der Teile wie in der Ansichtsleiste: Glas 1, Glas 2, Holzbox */
    var nGlass=surf.filter(function(s){return s==='glass';}).length;
    var names=surf.map(function(s,i){
      if(s==='wood')return 'Holzbox';
      return nGlass>1?'Glas '+surf.filter(function(z,j){return z==='glass'&&j<=i;}).length:'Glas';
    });

    /* Originalvorlagen merken und je Teil die gemeinsam genutzten Felder sammeln */
    E.sl.forEach(function(t){if(t.__wbOrig==null)t.__wbOrig=t[0];});
    var byKind={};GM.rows.forEach(function(r){byKind[r.kind]=r;});
    var parts=[];
    surf.forEach(function(s,i){
      if(i===0)return;
      var kinds=[];
      E.sl.forEach(function(t){
        if(t[1]!==i)return;
        t.__wbOrig.replace(/\{([\w@]+)\}/g,function(m,k){if(k.indexOf('@')<0&&byKind[k]&&kinds.indexOf(k)<0)kinds.push(k);});
      });
      if(kinds.length)parts.push({i:i,name:names[i],kinds:kinds,on:false,rows:{}});
    });
    if(!parts.length)return true;
    /* Reihenfolge der Felder wie bei Glas 1 */
    parts.forEach(function(p){p.kinds.sort(function(a,b){return GM.rows.indexOf(byKind[a])-GM.rows.indexOf(byKind[b]);});});

    var fields=wrap.querySelector('.gm-fields');
    if(!fields)return true;
    var head=document.createElement('p');
    head.className='wb-ind__head';
    fields.parentNode.insertBefore(head,fields);
    var box=document.createElement('div');
    box.className='wb-ind';
    fields.parentNode.insertBefore(box,fields.nextSibling);

    function labelOf(r){
      var l=r.field&&r.field.querySelector('.gm-label');
      if(!l)return r.kind;
      var c=l.cloneNode(true);c.querySelectorAll('.gm-label__hint').forEach(function(x){x.remove();});
      return c.textContent.trim();
    }
    function apply(){
      E.sl.forEach(function(t){
        var p=parts.filter(function(q){return q.i===t[1];})[0];
        t[0]=(p&&p.on)?t.__wbOrig.replace(/\{([\w@]+)\}/g,function(m,k){return p.kinds.indexOf(k)>-1?'{'+k+'__s'+p.i+'}':m;}):t.__wbOrig;
      });
      var same=[names[0]].concat(parts.filter(function(p){return !p.on;}).map(function(p){return p.name;}));
      head.textContent='Gravur für '+(same.length>1?same.slice(0,-1).join(', ')+' und '+same[same.length-1]:same[0]);
      try{GM.render();}catch(e){}
    }
    function view(i){var b=wrap.querySelector('.gm-seg button[data-v="s'+i+'"]');if(b&&b.getAttribute('aria-pressed')!=='true')b.click();}

    parts.forEach(function(p){
      var item=document.createElement('div');
      item.className='wb-ind__item';
      var cid='wb-ind-'+p.i;
      item.innerHTML='<label class="wb-ind__toggle" for="'+cid+'"><input type="checkbox" id="'+cid+'" checked><span><b>'+esc(p.name)+'</b> genauso gravieren wie '+esc(names[0])+'</span></label>'+
        '<div class="wb-ind__fields" hidden><p class="wb-ind__sub">Eigene Gravur für '+esc(p.name)+'</p></div>';
      var fwrap=item.querySelector('.wb-ind__fields');
      p.kinds.forEach(function(k){
        var src=byKind[k],lab=labelOf(src),id='wb-ind-'+p.i+'-'+k;
        var f=document.createElement('div');
        f.className='gm-field';
        f.innerHTML='<div class="gm-field__top"><label class="gm-label" for="'+id+'">'+esc(lab)+'</label><label class="gm-skip"><input type="checkbox"> Leer lassen</label></div><div class="gm-field__box"></div>';
        var inp=document.createElement('input');
        inp.type='text';inp.id=id;
        inp.className=src.input.className;
        inp.name='properties['+p.name+': '+lab+']';
        var ml=src.input.getAttribute('maxlength');if(ml)inp.setAttribute('maxlength',ml);
        inp.setAttribute('placeholder',src.input.getAttribute('placeholder')||'');
        inp.setAttribute('autocomplete','off');inp.setAttribute('spellcheck','false');
        var fa=src.input.getAttribute('form');if(fa)inp.setAttribute('form',fa);
        inp.required=true;inp.disabled=true;
        var cnt=document.createElement('span');cnt.className='gm-count';cnt.setAttribute('aria-hidden','true');
        var fb=f.querySelector('.gm-field__box');fb.appendChild(inp);fb.appendChild(cnt);
        var row={kind:k+'__s'+p.i,input:inp,src:src.src,fixed:src.fixed,ff:src.ff,ph:src.ph,pph:src.pph,max:src.max,count:cnt,field:f,font:null,g:f,head:src.head};
        var cb=f.querySelector('.gm-skip input');
        cb.setAttribute('aria-label',p.name+' '+lab+' leer lassen');
        cb.addEventListener('change',function(){
          if(cb.checked){if(inp.value!=='OHNE')row.saved=inp.value;inp.value='OHNE';inp.readOnly=true;f.classList.add('is-skipped');}
          else{inp.value=row.saved||'';inp.readOnly=false;f.classList.remove('is-skipped');}
          fire(inp,'input');GM.render();
        });
        row.cb=cb;
        inp.addEventListener('input',function(){GM.render();});
        inp.addEventListener('focus',function(){view(p.i);});
        p.rows[k]=row;
        fwrap.appendChild(f);
      });
      var tg=item.querySelector('.wb-ind__toggle input');
      tg.addEventListener('change',function(){
        p.on=!tg.checked;
        fwrap.hidden=!p.on;
        p.kinds.forEach(function(k){
          var r=p.rows[k],srcV=byKind[k].input.value;
          r.input.disabled=!p.on;
          var ix=GM.rows.indexOf(r);
          if(p.on){
            /* Text von Glas 1 übernehmen, damit nur das Abweichende geändert werden muss */
            if(!r.input.value&&srcV){
              if(srcV==='OHNE'){r.cb.checked=true;r.input.value='OHNE';r.input.readOnly=true;r.field.classList.add('is-skipped');}
              else r.input.value=srcV;
            }
            if(ix<0)GM.rows.push(r);
          }else if(ix>-1)GM.rows.splice(ix,1);
        });
        apply();
        if(p.on){view(p.i);var first=fwrap.querySelector('input[type=text]');if(first)first.focus({preventScroll:true});}
        document.dispatchEvent(new CustomEvent('wb:ind-change',{detail:{part:p.name,on:p.on}}));
      });
      box.appendChild(item);
    });
    apply();
    return true;
  }

  function start(){
    var n=0;
    (function look(){if(init()||++n>60)return;setTimeout(look,250);})();
  }
  document.addEventListener('gm:cfg-ready',function(){setTimeout(start,50);});
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
})();
